













import { defineComponent, ref, computed } from '@nuxtjs/composition-api'
import { Option } from '~/models/shared/types'
import { Facet, PurchaseTypesEnum } from '~/models/search/types'
import { useI18n } from '~/compositions/i18n'
import BaseSearchHandler from '~/components/car/classifieds/search/facets/handlers/BaseSearchHandler.vue'
import {
  emptyInstallmentsParams,
  emptyLeasingParams
} from '~/constants/search/facets'
import { useNamespacedStore } from '~/compositions/store'
import { SearchState } from '~/store/modules/shared/classifieds/search/state.ts'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import CRadioButtonGroup from '~/components/shared/configurable/button/CRadioButtonGroup.vue'

export default defineComponent({
  extends: BaseSearchHandler,
  components: { CRadioButtonGroup },
  setup() {
    const { t } = useI18n()

    const { getters } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)
    const selectedPurchaseType = ref(null)

    const getFacetByName = computed(() => getters('getFacetByName'))
    const leasingOptionsFacet = computed(
      (): Facet => getFacetByName.value('leasing_options')
    )
    const financeFacet = computed((): Facet => getFacetByName.value('finance'))
    const hasLeasing = computed(() => leasingOptionsFacet.value.visible)
    const purchaseTypeOptions = computed((): Option[] => {
      const options = [
        {
          text: t('buy::agora'.toString()),
          value: PurchaseTypesEnum.BUY
        }
      ]
      if (hasLeasing) {
        options.push({
          text: 'Leasing',
          value: PurchaseTypesEnum.LEASING
        })
      }
      return options
    })

    return {
      selectedPurchaseType,
      purchaseTypeOptions,
      financeFacet
    }
  },
  methods: {
    handlePurchaseTypeChange(purchaseType: PurchaseTypesEnum) {
      if (purchaseType === PurchaseTypesEnum.BUY) {
        this.emitParams([
          {
            name: 'finance',
            value: null
          },
          ...emptyInstallmentsParams,
          ...emptyLeasingParams
        ])
        return
      }
      this.emitParams([
        {
          name: 'finance',
          value: purchaseType
        },
        ...emptyInstallmentsParams,
        ...emptyLeasingParams
      ])
    },
    onBackendValues() {
      const selected = this.financeFacet?.values?.selected || []
      if (selected.includes(PurchaseTypesEnum.LEASING)) {
        this.selectedPurchaseType = PurchaseTypesEnum.LEASING
      } else {
        this.selectedPurchaseType = PurchaseTypesEnum.BUY
      }
    },
    onClearAll() {
      this.selectedPurchaseType = PurchaseTypesEnum.BUY
    },
    onClear() {
      this.emitParams([
        { name: 'finance', value: null },
        ...emptyInstallmentsParams,
        ...emptyLeasingParams
      ])
    }
  }
})
